import { useState } from "react";
import { createPortal } from "react-dom";
import { Modal } from "react-bootstrap";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { TEENUNIQUE_RULES_HTML } from "../../../data/rules/teenunique";

// Rules (i) for Unique Teenpatti until "teenunique" is merged into the shared data/casinoRulesHtml.js
// (the page only mounts this while VideoBox has no rules of its own for the game, so there is never
// a second panel). Same markup as VideoBox: the in-video panel goes into the empty div that follows
// .casino-video-right-icons, and when IS_MOBILE (<1280) the reference also opens the rules modal.
const TEENUNIQUE_RULES = TEENUNIQUE_RULES_HTML.split("__RULES_IMG__").join(
  `${import.meta.env.BASE_URL}img/casino-rules`
);

// clickSeq: number of (i) clicks so far (VideoBox onRulesClick); every click opens the panel (+ modal).
export default function TeenUniqueRules({ clickSeq = 0 }) {
  // Panel / modal are open while the latest click is newer than the one they were closed at.
  const [panelClosedAt, setPanelClosedAt] = useState(0);
  const [modalClosedAt, setModalClosedAt] = useState(0);
  const open = clickSeq > panelClosedAt;
  const showModal = IS_REF_MOBILE && clickSeq > modalClosedAt;
  const target = open
    ? document.querySelector(".casino-table.teenpatti20 > .casino-video > .casino-video-right-icons + div")
    : null;
  const closeModal = () => setModalClosedAt(clickSeq);

  return (
    <>
      {open &&
        target &&
        createPortal(
          <div
            id="casino-vieo-rules"
            aria-modal="true"
            className="casino-vieo-rules show d-none-small show-rules"
            style={{ display: "block" }}
          >
            <div className="rules-header">
              <div>Rules</div> <i className="fas fa-times" onClick={() => setPanelClosedAt(clickSeq)} />
            </div>{" "}
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: TEENUNIQUE_RULES }} />
          </div>,
          target
        )}
      <Modal
        show={showModal}
        onHide={closeModal}
        className="casino-rules teenpatti2-rule-modal"
        dialogClassName="modal-md"
        id="rules-modal"
      >
        <header className="modal-header">
          <h5 className="modal-title">Rules</h5>{" "}
          <button type="button" aria-label="Close" className="close" onClick={closeModal}>
            ×
          </button>
        </header>
        <Modal.Body>
          <div className="casino-vieo-rules show-rules show">
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: TEENUNIQUE_RULES }} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
